import { BaseClass } from './base-class';
import { BaseRepository } from '@interfaces/base-repository';
import { Site } from './site';
import { AddressGroup } from './address-group';

export class Address extends BaseClass implements BaseRepository {
  name: string;
  code?: string;
  street: string;
  streetNumber: string;
  locality: string;
  postalCode: string;
  isReceiver: boolean;
  isSender: boolean;
  sites: Site[];
  addressGroupIds: string[];
  addressGroups: AddressGroup[];
  phone: string;
  isChecked?: boolean;
  tags?: string[];
  services?: string[];

  constructor()
  constructor(
    name: string, street: string, streetNumber: string, locality: string, postalCode: string, isReceiver: boolean, isSender: boolean, sites: Site[], phone: string, tags?: string[], services?: string[])
  constructor(
    name?: string, street?: string, streetNumber?: string, locality?: string, postalCode?: string, isReceiver?: boolean, isSender?: boolean, sites?: Site[], phone?: string, tags?: string[], services?: string[]) {
    super();

    this.name = this.trim(name);
    this.street = this.trim(street);
    this.streetNumber = this.trim(streetNumber);
    this.locality = this.trim(locality);
    this.postalCode = this.trim(postalCode);
    this.isReceiver = isReceiver;
    this.isSender = isSender;
    this.sites = sites;
    this.addressGroupIds = [];
    this.addressGroups = [];
    this.phone = phone;
    this.services = services;
    if (tags) {
      tags.map(oneTag => {
        this.trim(oneTag).replace(' ', '').replace(':', '').toLowerCase();
      });
      this.tags = tags;
    }
  }

  static fromObject(object: Address): Address {
    return Object.assign(new Address(), {
      ...object,
      sites: object.sites?.map(o => Site.fromObject(o)) || [],
      addressGroupIds: object.addressGroupIds || [],
      addressGroups: object.addressGroups?.map(group => AddressGroup.fromObject(group)) || []
    });
  }

  get display(): string {
    return `${this.name}`;
  }

  doesInclude(value: string): boolean {
    return this.some([this.name], value);
  }
}
